export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  cover: string;
  body: string[];
  relatedMovieId: string;
  views: number;
  featured: boolean;
}

export const newsCategories = ["上映动态", "幕后花絮", "周边资讯", "行业观察"];

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "《神偷奶爸 4》全球票房突破 9 亿美元，小黄人依旧能打",
    category: "上映动态",
    date: "2024-08-20",
    summary: "上映一个多月，《神偷奶爸 4》全球累计票房正式突破 9 亿美元，成为 2024 年最卖座的动画电影之一，证明了小黄人 IP 经久不衰的号召力。",
    cover: "https://readdy.ai/api/search-image?query=Bright%20cheerful%20cinema%20lobby%20with%20yellow%20animated%20movie%20posters%20and%20tiny%20yellow%20characters%2C%20warm%20golden%20light%2C%20clean%20editorial%20photography%20style%2C%20family%20entertainment%20atmosphere&width=1200&height=675&seq=minion-news-01&orientation=landscape",
    body: [
      "据发行方公布的最新数据，《神偷奶爸 4》上映以来全球累计票房已正式突破 9 亿美元大关，其中北美市场贡献约 3.6 亿美元，海外市场表现尤为亮眼。",
      "作为系列第四部正传作品，影片延续了一贯的合家欢路线，格鲁一家与升级版小黄人的组合再次赢得观众青睐。多位影评人指出，虽然剧情套路并不新鲜，但小黄人天马行空的喜剧桥段依旧是票房的核心驱动力。",
      "值得一提的是，本片在流媒体上线前的长线放映表现稳定，家庭观众的口碑传播成为票房持续走高的重要因素。业内普遍预计，随着后续周边与流媒体发行，该片的总收益还将进一步攀升。",
    ],
    relatedMovieId: "despicable-me-4",
    views: 18200,
    featured: true,
  },
  {
    id: "news-02",
    title: "幕后揭秘：小黄人的配音是怎么做出来的？",
    category: "幕后花絮",
    date: "2023-06-11",
    summary: "小黄人们说的到底是什么语言？导演皮埃尔·柯芬亲自揭秘，那其实是一套融合了多国词汇的「小黄人语」，连他自己都要靠音效师帮忙记住。",
    cover: "https://readdy.ai/api/search-image?query=Recording%20studio%20microphone%20with%20warm%20yellow%20lighting%20and%20tiny%20animated%20creature%20plush%2C%20clean%20editorial%20behind%20the%20scenes%20photography%2C%20warm%20cozy%20tones&width=1200&height=675&seq=minion-news-02&orientation=landscape",
    body: [
      "很多观众好奇，小黄人们叽里咕噜的台词到底是什么语言。答案可能会让你意外——那是一套专门为角色发明的「小黄人语」。",
      "据导演皮埃尔·柯芬介绍，这套语言混合了西班牙语、法语、意大利语甚至部分英语单词，再加上大量拟声词构成。为了保持角色的辨识度，团队为不同小黄人设计了不同的音调与口癖。",
      "柯芬本人就是多只小黄人的配音者。他坦言，录音时经常需要音效团队在旁边提示发音，否则连他自己都会「说错词」。正是这种看似随意的设计，让小黄人跨越语言障碍，在全球范围内收获喜爱。",
    ],
    relatedMovieId: "minions-2015",
    views: 15600,
    featured: true,
  },
  {
    id: "news-03",
    title: "从衍生短片到独立系列，小黄人如何成为超级 IP",
    category: "行业观察",
    date: "2024-05-02",
    summary: "原本只是《神偷奶爸》中的配角，小黄人却凭借惊人的辨识度走出了一条独立的 IP 之路。这篇观察带你回顾它们从小配角到全球巨星的逆袭。",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20merchandise%20display%20shelf%20with%20yellow%20animated%20character%20figures%20and%20toys%2C%20warm%20retail%20lighting%2C%20clean%20editorial%20product%20photography%2C%20lively%20retail%20atmosphere&width=1200&height=675&seq=minion-news-03&orientation=landscape",
    body: [
      "在 2010 年第一部《神偷奶爸》上映时，没人能预料到这群黄色小家伙会成为全球最具商业价值的动画角色之一。",
      "小黄人的成功，源于极其鲜明的视觉符号：明亮的黄色、圆滚滚的身形、护目镜与背带裤。这种「一眼可辨」的设计，使它们天然适合做成玩具、文具和各类周边。",
      "从 2015 年的独立电影《小黄人大眼萌》，到数十部衍生短片，小黄人逐渐构建起脱离主角格鲁也能独立运转的内容生态。这种「配角反哺主系列」的模式，已成为动画行业的经典案例。",
    ],
    relatedMovieId: "minions-2015",
    views: 12400,
    featured: false,
  },
  {
    id: "news-04",
    title: "《小黄人大眼萌：神偷奶爸前传》曝全新中字预告",
    category: "上映动态",
    date: "2022-05-18",
    summary: "影片发布全新中字预告，少年格鲁与小黄人们的首次相遇、功夫大师周师父的登场悉数曝光，复古的七十年代质感令人眼前一亮。",
    cover: "https://readdy.ai/api/search-image?query=Retro%201970s%20cityscape%20at%20golden%20dusk%20with%20tiny%20yellow%20animated%20creatures%2C%20warm%20nostalgic%20color%20palette%2C%20clean%20editorial%20cinematic%20photography%20style&width=1200&height=675&seq=minion-news-04&orientation=landscape",
    body: [
      "全新中字预告片中，十一岁的格鲁怀揣反派梦想，第一次与小黄人们并肩作战。预告片大量展现了七十年代的复古美学，从服装到街区细节都充满年代感。",
      "本片的一大看点是功夫大师周师父的登场。由杨紫琼献声的这一角色，为格鲁的成长之路带来了关键转折，也让影片在喜剧之外多了几分热血。",
      "预告发布后迅速登上各大社交平台热搜，不少观众表示「看小黄人就是图一个开心」，对影片的合家欢定位给予高度期待。",
    ],
    relatedMovieId: "rise-of-gru",
    views: 14100,
    featured: false,
  },
  {
    id: "news-05",
    title: "小黄人主题乐园扩建，新增沉浸式互动体验区",
    category: "周边资讯",
    date: "2024-03-27",
    summary: "位于环球影城的小黄人主题园区宣布扩建，将新增沉浸式互动体验区，游客可以走进格鲁的实验室，与小黄人们一起完成任务。",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20theme%20park%20attraction%20with%20bright%20yellow%20decor%20and%20playful%20architecture%2C%20sunny%20warm%20day%2C%20clean%20editorial%20travel%20photography%2C%20joyful%20family%20vacation%20mood&width=1200&height=675&seq=minion-news-05&orientation=landscape",
    body: [
      "环球影城宣布，小黄人主题园区将迎来扩建，新增的沉浸式互动体验区预计于明年正式开放。",
      "根据规划，游客将可以走进格鲁的实验室，跟随虚拟导览完成一系列趣味任务，亲手体验影片中出现的各种「奇怪发明」。园区还将推出限定的主题餐饮与周边商品。",
      "运营方表示，小黄人园区自开放以来一直是最受欢迎的板块之一，此次扩建旨在缓解高峰期的排队压力，同时为家庭游客提供更丰富的游玩内容。",
    ],
    relatedMovieId: "despicable-me-4",
    views: 9800,
    featured: false,
  },
  {
    id: "news-06",
    title: "导演谈系列未来：小黄人的故事还远没有讲完",
    category: "行业观察",
    date: "2024-09-05",
    summary: "在接受采访时，系列主创透露未来仍有多个小黄人相关项目在筹备中，包括全新的独立故事与更多衍生短片，粉丝的热情成为创作的动力。",
    cover: "https://readdy.ai/api/search-image?query=Bright%20animation%20studio%20desk%20with%20sketches%20and%20storyboards%20in%20warm%20yellow%20lighting%2C%20clean%20editorial%20behind%20the%20scenes%20photography%2C%20creative%20inspiring%20atmosphere&width=1200&height=675&seq=minion-news-06&orientation=landscape",
    body: [
      "在最近的一次媒体采访中，系列主创团队透露，关于小黄人的创作灵感依然充沛，未来仍有多部作品在规划之中。",
      "主创表示，小黄人最大的魅力在于「没有台词也能让全世界都笑出来」，这让创作者可以不断尝试新的叙事形式，比如更长的独立故事与风格化的短片。",
      "不过团队也强调，任何新项目都会以「不辜负观众喜爱」为前提，宁可慢一点，也要保证每一部作品的质量与诚意。",
    ],
    relatedMovieId: "rise-of-gru",
    views: 8700,
    featured: false,
  },
  {
    id: "news-07",
    title: "小黄人联动公益：用笑声传递温暖与善意",
    category: "周边资讯",
    date: "2023-12-01",
    summary: "小黄人化身公益大使，与多家儿童慈善机构合作，通过主题活动和周边义卖，为需要帮助的孩子们送去温暖。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20charity%20event%20with%20yellow%20themed%20decorations%20and%20smiling%20children%2C%20soft%20golden%20light%2C%20clean%20editorial%20documentary%20photography%2C%20heartwarming%20community%20atmosphere&width=1200&height=675&seq=minion-news-07&orientation=landscape",
    body: [
      "这个冬天，小黄人不再只是银幕上的开心果，还成为了传递善意的公益大使。",
      "官方与多家儿童慈善机构合作，推出了限定周边义卖活动，所得款项将全部用于支持困境儿童的医疗与教育。同时，多场主题探访活动也让孩子们在笑声中感受到陪伴。",
      "主办方表示，小黄人所代表的乐观与温暖，正是公益最想传递的价值。未来这样的联动还将持续，让更多快乐被分享出去。",
    ],
    relatedMovieId: "minions-2015",
    views: 6900,
    featured: false,
  },
  {
    id: "news-08",
    title: "《神偷奶爸 3》蓝光特别版公开，收录未曝光删减片段",
    category: "幕后花絮",
    date: "2018-01-15",
    summary: "特别版蓝光碟正式公开，除了正片之外，还收录了多段从未曝光的删减片段与制作特辑，让影迷得以一窥幕后创作过程。",
    cover: "https://readdy.ai/api/search-image?query=Blu%20ray%20movie%20case%20collection%20on%20a%20wooden%20shelf%20with%20warm%20yellow%20lighting%2C%20clean%20editorial%20product%20photography%2C%20cozy%20home%20cinema%20atmosphere&width=1200&height=675&seq=minion-news-08&orientation=landscape",
    body: [
      "收藏爱好者迎来好消息，《神偷奶爸 3》蓝光特别版正式公开，为影迷带来满满的幕后内容。",
      "此次特别版收录了多段从未曝光的删减片段，包括小黄人集体出走的另外几个版本，以及主创团队关于角色设计的访谈特辑。",
      "此外，特别版还附赠了精美的艺术设定集，收录了数百张角色与场景的概念草图，对动画爱好者而言颇具收藏价值。",
    ],
    relatedMovieId: "despicable-me-3",
    views: 5400,
    featured: false,
  },
];

export const getNewsById = (id: string): NewsItem | undefined =>
  newsList.find((n) => n.id === id);